/* eslint-disable object-property-newline */
const Menu = [
  {
    path: "/monitor", icon: "fa fa-tv", title: "监控",
    children: [
      { path: "/monitor/perf", title: "前端性能" },
    ],
  },
  {
    path: "/asset", icon: "fa fa-cloud", title: "静态资源",
    children: [
      { path: "/asset/oss-upload", title: "OSS 上传" },
      // { path: '/form/elements', title: 'CDN 刷新' },
    ],
  },
  {
    path: "/tool", icon: "fa fa-wrench", title: "小工具",
    children: [
      { path: "/tool/tiny", title: "短链接生成" },
      // { path: '/form/elements', title: 'CDN 刷新' },
    ],
  },
];

export default Menu;
